<template>
  <!-- 企业 -->
  <el-select
    class="select"
    size="small"
    :style="{ width: '300px' }"
    v-model="searchValue"
    :loading="isLoading"
    filterable
    remote
    clearable
    :remote-method="getList"
    placeholder="请输入关键词"
  >
    <el-option v-for="item in list" :label="item.name" :value="item.id" :key="item.id"></el-option>
  </el-select>
</template>

<script>
import { getChannelListAPI } from './api.js'
export default {
  name: 'SelectChannel',

  computed: {
    searchValue: {
      get () {
        return this.value
      },

      set (val) {
        console.log(val,' @@@')
        this.$emit('input', val)
      }
    }
  },

  props: {
    value: {
      type: [String, Number],
      default: ''
    },
    type: {
      type: String,
      default: ''
    }
  },

  data () {
    return {
      list: [],
      isLoading: false
    }
  },

  created () {
    this.getList()
  },

  methods: {
    async getList () {
      this.list = await getChannelListAPI(this.type)
    }
  }
}
</script>

<style scoped lang="scss">
.select ::v-deep {
  .el-select__caret:first-child::before {
    content: '\e6e1';
  }
  .is-focus {
    .el-select__caret:first-child {
      transform: rotateZ(0deg);
    }
  }
}
</style>
